import _ from "lodash";
import React from "react";

import { useI18n } from "Hooks";
import {
  getRatingParentIconInfo,
  getRatingHistoryParentType,
} from "ClassProgressSummaryV2/modules/Utils";

import { ObservationIcon } from "SvgComponents";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";

import {
  ImageSquareOutlined,
  LinkOutlined,
  NoteOutlined,
  PlaceholderFileOutlined,
  PlayCircleOutlined,
  ProgressReportDuotone,
} from "@toddle-edu/ds-icons";
import { Avatar } from "@toddle-edu/ds-web";
import classes from "./Thumbnail.scss";

const ICON_MAPPER = {
  FILE: <PlaceholderFileOutlined variant="on" />,
  IMAGE: <ImageSquareOutlined variant="on" />,
  NOTE: <NoteOutlined variant="on" />,
  LINK: <LinkOutlined variant="on" />,
  VIDEO: <PlayCircleOutlined variant="on" />,
};

const Thumbnail = props => {
  const { parentType, parent, displayOn, isPopUp, thumbnailSize } = props;
  const { t } = useI18n(["common"]);

  const showSmallIcon = isPopUp && displayOn === "list";
  const styles = {
    smallIconContainer: {
      width: `${thumbnailSize}`,
      height: `${thumbnailSize}`,
    },
  };
  const ratingParentType = getRatingHistoryParentType({
    parent,
    parentType,
  });
  switch (ratingParentType) {
    case "STUDENT_PROGRESS_REPORT": {
      return (
        <div
          className={classes.progressReportIconContainer}
          style={thumbnailSize && styles.smallIconContainer}
        >
          <ProgressReportDuotone
            color="pink"
            size={showSmallIcon ? "xx-small" : "small"}
          />
        </div>
      );
    }
    case "STUDENT_ASSESSMENT_EVALUATION":
    case "STUDENT_ASSIGNMENT": {
      const {
        iconColor = "neutral",
        iconAssessmentTypeLabel,
      } = getRatingParentIconInfo({
        parentType: ratingParentType,
        parent,
        t,
      });
      if (displayOn === "list") {
        return (
          <Avatar
            shape="square"
            shade="light"
            color={iconColor}
            name={iconAssessmentTypeLabel}
            size={showSmallIcon ? "x-small" : "medium"}
          />
        );
      } else {
        const imageObjectPath =
          ratingParentType === "STUDENT_ASSIGNMENT"
            ? "assignment.content.image"
            : "assessment.image";
        const imageId = _.get(parent, `${imageObjectPath}.id`, {});
        const imageUrl = _.get(parent, `${imageObjectPath}.value`, null);
        return imageUrl ? (
          <div className={classes.assessmentImageHolder}>
            <ResourceImagePlaceHolder
              id={imageId}
              imageUrl={imageUrl}
              imageThumbSize={60}
            />
          </div>
        ) : (
          <Avatar
            size="medium"
            shape="square"
            shade="light"
            color={iconColor}
            name={iconAssessmentTypeLabel}
          />
        );
      }
    }
    case "POST": {
      const attachments = _.get(parent, "attachments", []);
      const firstAttachment = _.first(attachments);
      const attachmentType = _.get(firstAttachment, "type", "");
      if (!_.isEmpty(attachmentType)) {
        return (
          <div
            className={classes.postIcon}
            style={thumbnailSize && styles.smallIconContainer}
          >
            {ICON_MAPPER[attachmentType]}
          </div>
        );
      } else {
        return null;
      }
    }
    default: {
      return (
        <div
          className={classes.observationIcon}
          style={thumbnailSize && styles.smallIconContainer}
        >
          <ObservationIcon />
        </div>
      );
    }
  }
};

export default Thumbnail;
